const FooterContact = () => {
  return (
    <div className="flex flex-col h-full pb-4">
      <h1 className="font-bold md:text-2xl md:pb-4 text-center md:text-start">Contact</h1>
      <h2 className="text-center md:text-start">Address: 123 Main Street</h2>
      <h2 className="text-center md:text-start">Phone: (555) 123-4567 </h2>
      <h2 className="text-center md:text-start">Email: LittleLemon@gmail.com</h2>
    </div>
  );
};

export default FooterContact;
